// Translation lookup shared by the core `_()` (app.js) and the features' `sdk._` (features/sdk.jsx).
// `dict` maps English msgids to translations; a missing (or empty) entry falls back to `str`.
// `%1`..`%n` are replaced by the extra arguments; `%%1` is left as is.
export const format = (str, args) =>
    str.replace(/(^|[^%])%(\d+)/g, (m, first, pos) => first + args[pos - 1]);

export const translate = (dict, str, ...args) => {
    const translation = (dict && dict[str]) || str;
    if (translation == null) return str;
    return format(translation, args);
};
